import {
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  GoldOutlined,
  TableOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const financeiroBase: MenuConfigItem[] = [
  {
    label: "PAINEL GERAL",
    key: "/painelGeral",
    path: "/painelGeral",
    icon: <DashboardOutlined />,
  },
  {
    label: "SORTEIO",
    key: "/sorteioPai",
    path: "/sorteioPai",
    icon: <CalendarOutlined />,
    children: [
      {
        label: "CONTROLE DE APORTES",
        key: "/controleAporte",
        path: "/controleAporte",
      },
      {
        label: "ANEXOS",
        key: "/anexos",
        path: "/anexos",
      },
    ],
  },
  {
    label: "FINANCEIRO",
    key: "/financeiro",
    path: "/financeiro",
    icon: <DollarCircleOutlined />,
    children: [
      {
        label: "CONTAS A PAGAR",
        key: "/contaPagar",
        path: "/contaPagar",
      },
      {
        label: "CONTAS A RECEBER",
        key: "/contaReceber",
        path: "/contaReceber",
      },
      // {
      //   label: "CONTA RECORRENTE",
      //   key: "/contaRecorrente",
      //   path: "/contaRecorrente",
      // },
      {
        label: "LANÇAMENTOS FINANCEIROS",
        key: "/lancamentoFinanceiro",
        path: "/lancamentoFinanceiro",
      },
    ],
  },
  {
    label: "RESULTADOS",
    key: "/resultados",
    path: "/resultados",
    icon: <BarChartOutlined />,
    children: [
      {
        label: "RESULTADO DO SORTEIO",
        key: "/resultadoSorteio",
        path: "/resultadoSorteio",
      },
      {
        label: "COMPOSIÇÃO DE RESULTADO DA EMPRESA",
        key: "/composicao",
        path: "/composicao",
      },
    ],
  },
  {
    label: "RELATÓRIOS",
    key: "/relatorios",
    path: "/relatorios",
    icon: <FilePdfOutlined />,
    children: [
      {
        label: "MOVIMENTAÇÃO FINANCEIRA",
        key: "/relatorioMovimentacaoFinanceira",
        path: "/relatorioMovimentacaoFinanceira",
      },
      {
        label: "CONTAS BANCÁRIAS",
        key: "/relatorioContaBancaria",
        path: "/relatorioContaBancaria",
      },
      {
        label: "CONTAS BANCÁRIAS CONSOLIDADAS",
        key: "/relatorioConsolidadoSaldoBancario",
        path: "/relatorioConsolidadoSaldoBancario",
      },
      {
        label: "LANÇAMENTOS",
        key: "/relatorioLancamentos",
        path: "/relatorioLancamentos",
      },
    ],
  },
  {
    label: "CONSIGNATÁRIOS",
    key: "/consignatarios",
    path: "/consignatarios",
    icon: <UserOutlined />,
    children: [
      {
        label: "CARTEIRA DOS CONSIGNATÁRIOS",
        key: "/lancamentoConsignatario",
        path: "/lancamentoConsignatario",
      },
      {
        label: "CONTROLE DE COMPROVANTES DOS CONSIGNATÁRIOS",
        key: "/controleComprovanteConsignatario",
        path: "/controleComprovanteConsignatario",
      },
      {
        label: "IMPORTAÇÃO DAS VENDAS DOS CONSIGNATÁRIOS",
        key: "/importacaoVendaConsignatario",
        path: "/importacaoVendaConsignatario",
      },
      {
        label: "SALDO CONSIGNATÁRIOS",
        key: "/relatorioSaldoConsignatario",
        path: "/relatorioSaldoConsignatario",
      },
      {
        label: "CRÉDITOS DOS CONSIGNATÁRIOS",
        key: "/relatorioCreditosConsignatario",
        path: "/relatorioCreditosConsignatario",
      },
      {
        label: "NOTAS FISCAIS",
        key: "/notasFiscais",
        path: "/notasFiscais",
      },
    ],
  },
  {
    label: "GERAL",
    key: "/geral",
    path: "/geral",
    icon: <FileProtectOutlined />,
    children: [
      {
        label: "CONSIGNATÁRIOS",
        key: "/consignatario",
        path: "/consignatario",
      },
      {
        label: "PESSOAS",
        key: "/pessoa",
        path: "/pessoa",
      },
    ],
  },
];
